export default "__VITE_ASSET__DWG5_$4s__"